import { render } from "./LabelsWrapper.vue?vue&type=template&id=524386f0&scoped=true"
import script from "./LabelsWrapper.vue?vue&type=script&lang=js"
export * from "./LabelsWrapper.vue?vue&type=script&lang=js"

import "./LabelsWrapper.vue?vue&type=style&index=0&id=524386f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524386f0"]])

export default __exports__